export enum State {
    Email = 1, Create = 2
}


// WEBPACK FOOTER //
// ./src/app/solar/classes/components/wizard/class-instructor/edit-instructor/state.module.ts